// ─── Page ───
export const viewRuleContainerSx = { p: 3 };

export const viewRuleHeaderSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
};

export const viewRuleTitleSx = {
  fontFamily: 'Nunito',
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#232323',
};

export const editBtnSx = {
  borderRadius: '0.5rem',
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  color: '#505050',
  borderColor: '#E0E0E0',
  '&:hover': { borderColor: '#CCCCCC', backgroundColor: '#F5F5F5' },
  px: 2.5,
  py: 0.8,
};

// ─── Section ───
export const viewSectionBoxSx = {
  mb: 2,
  pb: 2,
  borderBottom: '1px solid #E2E3E5',
};

export const viewSectionTitleSx = {
  fontFamily: 'Nunito',
  fontWeight: 700,
  fontSize: '0.9375rem',
  color: '#232323',
  mb: 2,
};

// ─── Detail Item ───
export const detailLabelSx = {
  fontFamily: 'Nunito',
  fontWeight: 400,
  fontSize: '0.8125rem',
  color: '#9E9E9E',
  mb: 0.3,
};

export const detailValueSx = {
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.9375rem',
  color: '#232323',
};

// ─── Level Card ───
export const levelCardSx = {
  background: '#F8F8F9',
  borderRadius: '0.75rem',
  p: 2.5,
  mb: 2,
};

// ─── Footer ───
export const viewFooterSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  pt: 3,
};

export const backToListBtnSx = {
  borderRadius: '0.5rem',
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  backgroundColor: '#1F2937',
  '&:hover': { backgroundColor: '#111827' },
  px: 3,
  py: 1,
};
